export function route(
  endpoint: string,
  params: Record<string, string> = {},
  query: Record<string, string> = {},
): string {
  const url = Object.entries(params).reduce((acc, [key, value]) => {
    const paramRegex = new RegExp(`:${key}`, "g");
    // Encode so values containing path separators (e.g. a GitHub "owner/repo"
    // id) stay a single path segment and still match a ":param" route.
    return acc.replace(paramRegex, encodeURIComponent(value));
  }, endpoint);

  if (Object.keys(query).length > 0) {
    const queryString = new URLSearchParams(query).toString();
    return `${url}?${queryString}`;
  }

  return url;
}
